import { initContract } from '@ts-rest/core'
import { ErrorResponseSchema } from './general'
import { PaymentMethodSchema } from '@repo/api-types'
import z from 'zod'
import { ManualChargeOrderResultSchema } from '@lyka-pet-food/contracts'

const c = initContract()

export const paymentContract = c.router(
  {
    updateDefaultPaymentMethod: {
      method: 'PUT',
      path: '/payment-methods/default',
      body: z.object({
        paymentMethodId: z.string(),
        provider: z.string(),
      }),
      responses: {
        200: PaymentMethodSchema,
      },
    },
    getDefaultPaymentMethod: {
      method: 'GET',
      path: '/payment-methods/default',
      responses: {
        200: PaymentMethodSchema,
      },
    },
    retryPayment: {
      method: 'POST',
      path: '/payment/retry',
      body: z.object({
        orderId: z.string(),
      }),
      responses: {
        200: ManualChargeOrderResultSchema,
      },
    },
    getPaymentMethods: {
      method: 'GET',
      path: '/payment-methods',
      responses: {
        200: z.array(PaymentMethodSchema),
      },
    },
  },
  {
    commonResponses: {
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
)
